import type { ClassificationContent } from '@classification-testing/domain';
import { ContentType } from '@classification-testing/domain';
import { useCallback } from 'react';

interface UseContentHandlersProps {
  onContentChange: (content: ClassificationContent) => void;
  clearError: () => void;
}

/**
 * Custom hook to handle content change operations
 * Reduces complexity in the main component by consolidating handler logic
 */
export function useContentHandlers({ onContentChange, clearError }: UseContentHandlersProps) {
  const handleTextChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const newText = e.target.value;

      onContentChange({
        type: ContentType.TEXT,
        text: newText,
      });

      clearError();
    },
    [onContentChange, clearError]
  );

  const handleImageUrlChange = useCallback(
    (newImageUrl: string) => {
      onContentChange({
        type: ContentType.IMAGE,
        imageUrl: newImageUrl,
        imageName: newImageUrl,
      });

      clearError();
    },
    [onContentChange, clearError]
  );

  return {
    handleTextChange,
    handleImageUrlChange,
  };
}
